module.exports = __webpack_public_path__ + "static/media/footer_3.36ee3cd9.png";